import { render, staticRenderFns } from "./DuplicationOverlay.vue?vue&type=template&id=795fae6b&scoped=true&"
import script from "./DuplicationOverlay.vue?vue&type=script&lang=js&"
export * from "./DuplicationOverlay.vue?vue&type=script&lang=js&"
import style0 from "./DuplicationOverlay.vue?vue&type=style&index=0&id=795fae6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fae6b",
  null
  
)

export default component.exports